<template>
  <div class="home-div font-color-1">
    <SideBar />
    <div class="contain-div">
      <div class="contain-left mbl-no-hover">
        <div style="padding: 2px 2px">
          <div class="user-mid">
            <div>
              网名：<input class="user-input" type="text" v-model="UserInfo.name" placeholder="请输入网名" />
            </div>
            <div>
              家乡：<input class="user-input" type="text" v-model="UserInfo.hometown" placeholder="请输入家乡" />
            </div>
          </div>
          <div class="user-mid">
            <div>
              邮箱：<input class="user-input" type="text" v-model="UserInfo.email" placeholder="请输入邮箱" />
            </div>
            <div>
              域名：<input class="user-input" type="text" v-model="UserInfo.domainName" placeholder="请输入域名" />
            </div>
          </div>
          <div class="user-mid">
            <div>
              抖音：<input class="user-input" type="text" v-model="UserInfo.dyUrl" placeholder="请输入抖音地址" />
            </div>
            <div>
              红书：<input class="user-input" type="text" v-model="UserInfo.xhsUrl" placeholder="请输入小红书地址" />
            </div>
          </div>
          <div>
            站长的自述：<textarea class="user-input" rows="4" type="text" v-model="UserInfo.sign"
              placeholder="请输入对于自己的描述信息"></textarea>
          </div>
          <div>
            喜欢的电影：<textarea class="user-input" rows="4" type="text" v-model="UserInfo.movies"
              placeholder="请输入喜欢的电影"></textarea>
          </div>
          <div>
            喜欢的动漫：<textarea class="user-input" rows="4" type="text" v-model="UserInfo.anime"
              placeholder="请输入喜欢的动漫"></textarea>
          </div>
          <div>
            喜欢的游戏：<textarea class="user-input" rows="4" type="text" v-model="UserInfo.games"
              placeholder="请输入喜欢的游戏"></textarea>
          </div>
          <div>
            了栀林描述：<textarea class="user-input" rows="4" type="text" v-model="UserInfo.descInfo"
              placeholder="请输入了栀林描述"></textarea>
          </div>
        </div>
        <div class="user-bottom">
          <div style="display: flex;flex-direction: column;justify-content: space-around;">
            <el-upload class="user-link_img" :action="upWxUrl" :show-file-list="false"
              :on-success="handleAvatarSuccessWx" :before-upload="beforeAvatarUpload">
              <img v-if="wxUrl" :src="wxUrl" class="user-link_img" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <div>微信</div>
          </div>
          <div style="display: flex;flex-direction: column;justify-content: space-around;">
            <el-upload class="user-link_img" :action="upPortraitUrl" :show-file-list="false"
              :on-success="handleAvatarSuccessPortrait" :before-upload="beforeAvatarUpload">
              <img v-if="portraitUrl" :src="portraitUrl" class="user-link_img" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <div>肖像</div>
          </div>
          <div style="display: flex;flex-direction: column;justify-content: space-around;">
            <el-upload class="user-link_img" :action="upDrawUrl" :show-file-list="false"
              :on-success="handleAvatarSuccessDraw" :before-upload="beforeAvatarUpload">
              <img v-if="drawUrl" :src="drawUrl" class="user-link_img" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <div>主题</div>
          </div>
        </div>
        <div class="button-group">
          <button class="btn-login" @click="handleSaveUserInfo">
            提交个人信息
          </button>
        </div>
      </div>
      <div class="contain-right mbl-no-hover">
        <div class="admin-left">
          <div class="admin-item">
            <div class="admin-item-title">年度管理</div>
            <div style="display: flex;justify-content: space-around;margin-top: 10px;">
              <div class="admin-item-info" @click="handleShow((type = TypeEnum.CREATE_YEAR))">
                创建年度
              </div>
              <div class="admin-item-info" @click="handleShowTable((type = TypeEnum.SHOW_YEAR), (action = 0))">
                年度列表
              </div>
            </div>
            <div class="admin-item-title">音乐管理</div>
            <div style="display: flex;justify-content: space-around;margin-top: 10px;">
              <div class="admin-item-info" @click="handleShow((type = TypeEnum.CREATE_MUSIC))">
                创建音乐
              </div>
              <div class="admin-item-info" @click="handleShowTable((type = TypeEnum.SHOW_MUSIC), (action = 0))">
                音乐列表
              </div>
            </div>
            <div class="admin-item-title">弹幕评论管理</div>
            <div style="display: flex;justify-content: space-around;margin-top: 10px;">
              <div class="admin-item-info" @click="handleShowTable((type = TypeEnum.SHOW_DANMAKU), (action = 0))">
                弹幕列表
              </div>
              <div class="admin-item-info" @click="handleShowTable((type = TypeEnum.SHOW_COMMENT), (action = 0))">
                评论列表
              </div>
            </div>
            <div class="admin-item-title">友链管理</div>
            <div style="display: flex;justify-content: space-around;margin-top: 10px;">
              <div class="admin-item-info" @click="handleShow((type = TypeEnum.CREATE_FRIEND_LINK))">
                创建友链
              </div>
              <div class="admin-item-info" @click="handleShowTable((type = TypeEnum.SHOW_FRIEND_LINK), (action = 0))">
                友链列表
              </div>
            </div>
            <div class="admin-item-title">游记管理</div>
            <div style="display: flex;justify-content: space-around;margin-top: 10px;">
              <div class="admin-item-info" @click="handleShow((type = TypeEnum.CREATE_TRAVELS))">
                创建游记
              </div>
              <div class="admin-item-info" @click="handleShowTable((type = TypeEnum.SHOW_TRAVELS), (action = 0))">
                游记列表
              </div>
            </div>
          </div>
        </div>
        <div class="admin-right">
          <div class="admin-item">
            <div class="admin-item-title">故事管理</div>
            <div style="display: flex;justify-content: space-around;margin-top: 10px;">
              <div class="admin-item-info" @click="handleShow((type = TypeEnum.CREATE_LIFE))">
                发布故事
              </div>
              <div class="admin-item-info" @click="handleShowTable((type = TypeEnum.SHOW_LIFE), (action = 0))">
                故事列表
              </div>
              <div class="admin-item-info" @click="handleShow((type = TypeEnum.CREATE_LIFE_TYPE))">
                创建类别
              </div>
              <div class="admin-item-info" @click="handleShowTable((type = TypeEnum.SHOW_LIFE_TYPE), (action = 0))">
                类别列表
              </div>
            </div>
            <div class="admin-item-title">工具管理</div>
            <div style="display: flex;justify-content: space-around;margin-top: 10px;">
              <div class="admin-item-info" @click="handleShow((type = TypeEnum.CREATE_INSTR))">
                创建工具
              </div>
              <div class="admin-item-info" @click="handleShowTable((type = TypeEnum.SHOW_INSTR), (action = 0))">
                工具列表
              </div>
              <div class="admin-item-info" @click="handleShow((type = TypeEnum.CREATE_INSTR_TYPE))">
                创建类别
              </div>
              <div class="admin-item-info" @click="handleShowTable((type = TypeEnum.SHOW_INSTR_TYPE), (action = 0))">
                类别列表
              </div>
            </div>
            <div class="admin-item-title">相册管理</div>
            <div style="display: flex;justify-content: space-around;margin-top: 10px;">
              <div class="admin-item-info" @click="handleShow((type = TypeEnum.CREATE_ABLUM))">
                创建相册
              </div>
              <div class="admin-item-info" @click="handleShowTable((type = TypeEnum.SHOW_ALBUM), (action = 0))">
                相册列表
              </div>
              <div class="admin-item-info" @click="handleShow((type = TypeEnum.CREATE_ABLUM_TYPE))">
                创建类别
              </div>
              <div class="admin-item-info" @click="handleShowTable((type = TypeEnum.SHOW_ALBUM_TYPE), (action = 0))">
                类别列表
              </div>
            </div>
            <div class="admin-item-title">系统管理</div>
            <div style="display: flex;justify-content: space-around;margin-top: 10px;">
              <div class="admin-item-info" @click="handleShow((type = TypeEnum.SYS_CONFIG))">
                系统配置
              </div>
              <div class="admin-item-info">系统日志</div>
              <div class="admin-item-info">资源监控</div>
              <div class="admin-item-info">数据统计</div>
            </div>
            <div class="admin-item-title">配置管理</div>
            <div style="display: flex;justify-content: space-around;margin-top: 10px;">
              <div class="admin-item-info" @click="handleShow((type = TypeEnum.CURATED_ALBUM))">
                精选配置
              </div>
            </div>
          </div>
        </div>
      </div>

      <CreateMusic :isVisible="showMusicInfo" :MusicInfo="MusicInfo" @close="handleShow($event)"
        @update:visible="showMusicInfo = $event" />

      <CreateMuseumDetail :isVisible="showMuseumDetailInfo" :MuseumDetailInfo="MuseumInfo" @close="handleShow($event)"
        @update:visible="showMuseumDetailInfo = $event" />

      <CreateMuseumType :isVisible="showMuseumInfo" :museumType="MuseumInfo" @close="handleShow($event)"
        @update:visible="showMuseumInfo = $event" />

      <CreateInstr :isVisible="showInstrInfo" @close="handleShow($event)" @update:visible="showInstrInfo = $event"
        :InstrInfo="InstrInfo" />

      <SysConfig :isVisible="showSysConfigInfo" @close="handleShow($event)" @update:visible="showSysConfigInfo = $event"
        :sysConfigInfo="SysConfigInfo" />

      <CreateInstrType :isVisible="showInstrType" @close="handleShow($event)" @update:visible="showInstrType = $event"
        :instrType="InstrTypeInfo" />

      <CreateLifeType :isVisible="showLifeType" @close="handleShow($event)" @update:visible="showLifeType = $event"
        :lifeType="LifeTypeInfo" />

      <CreateFriendLink :isVisible="showFriendLink" @close="handleShow($event)"
        @update:visible="showFriendLink = $event" :friendLink="friendLink" />

      <CreateMilestoneInfo :isVisible="showMilestoneInfo" @close="handleShow($event)"
        @update:visible="showMilestoneInfo = $event" :MilestoneInfo="MilestoneInfo" />

      <AdminTableDisplay :isVisible="showTable" @close="closeAdminTable()" @update:visible="showTable = $event"
        class="modal-content" :columns="columns" :table-data="tableData" :event-type="eventType" :total="total"
        :page="page" :limit="limit" :loading="loading" @page-change="handlePageChange" @size-change="handleSizeChange"
        @action-event="handleAction" />

        <ImageSortGrid 
      :isVisible="showImageSortGrid" @close="handleShow($event)" @update:visible="showImageSortGrid = $event"
      v-model="imageList" 
      @save="handleSave"
      ref="sortGrid"
    />
    </div>
    <BottomTip />
  </div>
</template>

<script>
import SideBar from "@/components/menu/SideBar.vue";
import BottomTip from "@/components/menu/BottomTip.vue";
import AdminTableDisplay from "@/components/AdminTableDisplay.vue";
import CreateCpInfo from "@/components/CreateCpInfo.vue";
import CreateMilestoneInfo from "@/components/CreateMilestoneInfo.vue";
import CreateInstrType from "@/components/CreateInstrType.vue";
import { Message } from "element-ui";
import CreateInstr from "@/components/CreateInstr.vue";
import CreateMuseumType from "@/components/CreateMuseumType.vue";
import CreateMuseumDetail from "@/components/CreateMuseumDetail.vue";
import CreateMusic from "@/components/CreateMusic.vue";
import CreateFriendLink from "@/components/CreateFriendLink.vue";
import CreateLifeType from "@/components/CreateLifeType.vue";
import SysConfig from "@/components/SysConfig.vue";

import config from "@/utils/Config";
import { TypeEnum } from "@/utils/TypeEnum";
import DataAuth from "@/utils/DataAuth";
import router from "@/router";

import { getUserInfo } from "@/api/home";
import { upUserInfo } from "@/api/user";
import { getMusicListByPage, delMusic } from "@/api/music";
import { getAdminMilestoneList, delMilestone } from "@/api/milestone";
import {
  getInstrTypeAdminList,
  delInstrType,
  getInstrAdminListByPage,
  delInstrInfo,
} from "@/api/instr";
import { getLifeAdminList, delLife, delLifeType, getLifeTypeAdminList} from "@/api/life";
import { getFriendListByPage, delFriend } from "@/api/friendLink";
import {
  getAdminAlbumTypeList,
  delAlbumTypeInfo,
  getAlbumList,
  del,
  getCuratedAlbumLit,
  saveImageSort
} from "@/api/album";

import { getAdminDanmakuList, delDanmaku } from "@/api/danmaku";
import { getAdminCommentList, delComment } from "@/api/comments";
import { getConfig } from "@/api/config";
import ImageSortGrid from "@/components/ImageSortGrid.vue";

export default {
  name: "Admin",
  components: {
    SideBar,
    BottomTip,
    AdminTableDisplay,
    CreateCpInfo,
    CreateMilestoneInfo,
    CreateInstrType,
    CreateInstr,
    CreateMuseumType,
    CreateMuseumDetail,
    CreateMusic,
    CreateFriendLink,
    CreateLifeType,
    SysConfig,
    ImageSortGrid
  },
  data() {
    return {
      TypeEnum: TypeEnum,
      UserInfo: {},

      showFriendLink: false,
      friendLink: {},

      showMusicInfo: false,
      showMilestoneInfo: false,
      showInstrInfo: false,
      showMuseumInfo: false,
      MuseumInfo: {},
      showMuseumDetailInfo: false,
      MilestoneInfo: {},
      InstrInfo: {},
      MusicInfo: {},

      showInstrType: false,
      InstrTypeInfo: {},
      showSysConfigInfo: false,
      SysConfigInfo: {},
      showLifeType: false,
      LifeTypeInfo: {},

      showTable: false,
      loading: false,
      eventType: "",
      page: 1, limit: 5, total: 0, status: -1,
      columns: [], tableData: [],

      upAvatarUrl: config.BASE_URL + config.upUserAvatarUrl,
      upWxUrl: config.BASE_URL + config.upUserWxUrl,
      upPortraitUrl: config.BASE_URL + config.upUserPortraitUrl,
      upDrawUrl: config.BASE_URL + config.upUserDrawUrl,
      imageUrl: "",
      wxUrl: "",
      portraitUrl: "",
      drawUrl: "",
      imageList: [
        { "id": 1, "url": "https://picsum.photos/seed/1/200/200", "showSort": 1 },
        { "id": 2, "url": "https://picsum.photos/seed/2/200/200", "showSort": 2 },
        { "id": 3, "url": "https://picsum.photos/seed/3/200/200", "showSort": 3 },
        { "id": 4, "url": "https://picsum.photos/seed/4/200/200", "showSort": 4 },
        { "id": 5, "url": "https://picsum.photos/seed/5/200/200", "showSort": 5 },
        { "id": 6, "url": "https://picsum.photos/seed/6/200/200", "showSort": 6 },
        { "id": 7, "url": "https://picsum.photos/seed/7/200/200", "showSort": 7 },
        { "id": 8, "url": "https://picsum.photos/seed/8/200/200", "showSort": 8 },
        { "id": 9, "url": "https://picsum.photos/seed/9/200/200", "showSort": 9 },
        { "id": 10, "url": "https://picsum.photos/seed/10/200/200", "showSort": 10 }
      ],
      showImageSortGrid: false
    };
  },
  async mounted() {
    await this.getUserInfo();
    await this.getCuratedAlbumLitInfo();
  },
  methods: {
    async getCuratedAlbumLitInfo() {
      try {
        const resp = await getCuratedAlbumLit({});
        if (resp.data && resp.code === 200) this.imageList = resp.data;
      } catch (error) { Message.error('获取精选集错误！'); this.imageList = []; }
    },
    // 处理保存事件
    async handleSave(payload) {
      try {
        const resp = await saveImageSort(payload);
        if (resp.code === 200) {
          Message.success('保存成功！');
          this.getCuratedAlbumLitInfo(); // 保存成功后重新获取数据
          this.$refs.sortGrid.doneSaving(true);
        } else {
          Message.error('保存失败：' + resp.msg);
        }
      } catch (error) {
        Message.error('保存失败，请重试！');
      }
    },
    async handleShow(event) {
      switch (event) {
        case TypeEnum.CREATE_LIFE_TYPE: this.showLifeType = !this.showLifeType; break;
        case TypeEnum.CREATE_YEAR: this.showMilestoneInfo = !this.showMilestoneInfo; break;
        case TypeEnum.CREATE_MUSIC: this.showMusicInfo = !this.showMusicInfo; break;
        case TypeEnum.CREATE_INSTR: this.showInstrInfo = !this.showInstrInfo; break;
        case TypeEnum.CREATE_INSTR_TYPE: this.showInstrType = !this.showInstrType; break;
        case TypeEnum.CREATE_FRIEND_LINK: this.showFriendLink = !this.showFriendLink; break;
        case TypeEnum.CREATE_ABLUM: this.showMuseumDetailInfo = !this.showMuseumDetailInfo; break;
        case TypeEnum.CREATE_ABLUM_TYPE: this.showMuseumInfo = !this.showMuseumInfo; break;
        case TypeEnum.CREATE_LIFE: router.push("/pub"); break;
        case TypeEnum.CREATE_TRAVELS: router.push("/pub-travels"); break;
        case TypeEnum.CURATED_ALBUM: this.showImageSortGrid = !this.showImageSortGrid; break;
        case TypeEnum.SYS_CONFIG:
          const resp = await getConfig();
          if (resp.code === 200 && resp.data) this.SysConfigInfo = resp.data;
          else { Message.error("获取配置失败"); return; }
          this.showSysConfigInfo = !this.showSysConfigInfo;
          break;
      }
    },

    async getUserInfo() {
      const resp = await getUserInfo({ id: config.BASE_USER_ID });
      this.UserInfo = resp.data;
      this.imageUrl = config.BASE_FILE_URL + resp.data.avatar;
      this.wxUrl = config.BASE_FILE_URL + resp.data.wxImg;
      this.portraitUrl = config.BASE_FILE_URL + resp.data.portrait;
      this.drawUrl = config.BASE_FILE_URL + resp.data.draw;
      return resp;
    },

    closeAdminTable() {
      this.eventType = ""; this.page=1; this.limit=5; this.total=0; this.columns=[]; this.tableData=[];
      this.showTable = true;
    },

    async handleShowTable(event, action) {
      this.eventType = event;
      if (action === 0) { this.page=1; this.limit=5; this.total=0; this.columns=[]; this.tableData=[]; }
      const PageQo = { page: this.page, limit: this.limit, status: this.status };
      let resp = null;
      switch (event) {
        case TypeEnum.SHOW_YEAR: resp = await getAdminMilestoneList(PageQo); break;
        case TypeEnum.SHOW_INSTR_TYPE: resp = await getInstrTypeAdminList(PageQo); break;
        case TypeEnum.SHOW_INSTR: resp = await getInstrAdminListByPage(PageQo); break;
        case TypeEnum.SHOW_ALBUM_TYPE: resp = await getAdminAlbumTypeList(PageQo); break;
        case TypeEnum.SHOW_ALBUM: resp = await getAlbumList(PageQo); break;
        case TypeEnum.SHOW_LIFE: resp = await getLifeAdminList(PageQo); break;
        case TypeEnum.SHOW_LIFE_TYPE: resp = await getLifeTypeAdminList(PageQo); break;
        case TypeEnum.SHOW_MUSIC: resp = await getMusicListByPage(PageQo); break;
        case TypeEnum.SHOW_FRIEND_LINK: resp = await getFriendListByPage(PageQo); break;
        case TypeEnum.SHOW_DANMAKU: resp = await getAdminDanmakuList(PageQo); break;
        case TypeEnum.SHOW_COMMENT: resp = await getAdminCommentList(PageQo); break;
        case TypeEnum.SHOW_TRAVELS: resp = await getTravelList(PageQo); break;
      }
      if (!resp) { Message.error("请求失败"); return; }
      if (resp.code !== 200) { Message.error(resp.msg); return; }
      this.page = resp.data.page;
      this.limit = resp.data.limit;
      this.total = resp.data.totalSize;
      const dataMap = resp.data.data;
      if (dataMap) { this.columns = dataMap.columns; this.tableData = dataMap.tableData; }
      this.showTable = true;
    },

    handlePageChange(page) { this.page = page; this.fetchData(); },
    handleSizeChange(size) { this.limit = size; this.fetchData(); },
    async handleAction({ event, row }) {
      if (event === "edit") this.handleEdit(row);
      else if (event === "delete") await this.handleDelete(row);
    },
    fetchData() { this.handleShowTable(this.eventType, 1); },
    handleEdit(row) { console.log("编辑", row); },

    async handleDelete(row) {
      let id = row.id || row.text;
      let resp = null;
      switch (this.eventType) {
        case TypeEnum.SHOW_YEAR: resp = await delMilestone(id); break;
        case TypeEnum.SHOW_INSTR_TYPE: resp = await delInstrType(id); break;
        case TypeEnum.SHOW_INSTR: resp = await delInstrInfo(id); break;
        case TypeEnum.SHOW_ALBUM_TYPE: resp = await delAlbumTypeInfo(id); break;
        case TypeEnum.SHOW_ALBUM: resp = await del(id); break;
        case TypeEnum.SHOW_LIFE: resp = await delLife(id); break;
        case TypeEnum.SHOW_LIFE_TYPE: resp = await delLifeType(id); break;
        case TypeEnum.SHOW_MUSIC: resp = await delMusic(id); break;
        case TypeEnum.SHOW_FRIEND_LINK: resp = await delFriend(id); break;
        case TypeEnum.SHOW_DANMAKU: resp = await delDanmaku(id); break;
        case TypeEnum.SHOW_COMMENT: resp = await delComment(id); break;
      }
      if (!resp) { Message.error("请求失败"); return; }
      if (resp.code !== 200) { Message.error(resp.msg); return; }
      Message.success("删除成功");
      this.fetchData();
    },

    async handleSaveUserInfo() {
      const userDto = {
        id: this.UserInfo.id,
        name: this.UserInfo.name,
        domainName: this.UserInfo.domainName,
        email: this.UserInfo.email,
        hometown: this.UserInfo.hometown,
        descInfo: this.UserInfo.descInfo,
        movies: this.UserInfo.movies,
        anime: this.UserInfo.anime,
        games: this.UserInfo.games,
        sign: this.UserInfo.sign,
        dyUrl: this.UserInfo.dyUrl,
        xhsUrl: this.UserInfo.xhsUrl,
        wxImg: this.UserInfo.wxImg,
        portrait: this.UserInfo.portrait,
        draw: this.UserInfo.draw
      };
      const resp = await upUserInfo(userDto);
      DataAuth.validateResp(resp);
    },

    // 微信上传
    handleAvatarSuccessWx(res) {
      if (res.code === 200) {
        this.wxUrl = res.data;
        this.UserInfo.wxImg = res.data;
        Message.success("微信上传成功");
      } else Message.error("上传失败");
    },

    // 肖像上传
    handleAvatarSuccessPortrait(res) {
      if (res.code === 200) {
        this.portraitUrl = res.data;
        this.UserInfo.portrait = res.data;
        Message.success("肖像上传成功");
      } else Message.error("上传失败");
    },

    // 主题上传
    handleAvatarSuccessDraw(res) {
      if (res.code === 200) {
        this.drawUrl = res.data;
        this.UserInfo.draw = res.data;
        Message.success("主题上传成功");
      } else Message.error("上传失败");
    },

    beforeAvatarUpload(file) {
      const isImage = file.type.includes("image");
      const isLt2M = file.size / 1024 / 1024 < 20;
      if (!isImage) { Message.error("只能上传图片"); return false; }
      if (!isLt2M) { Message.error("图片不能超过20MB"); return false; }
      return true;
    }
  },
};
</script>

<style scoped>
.modal-content {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  overflow: auto;
  z-index: 999;
  background: rgba(0, 0, 0, 0.8);
  padding: 5px;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
}

.admin-item-info {
  width: 40%;
  padding: 20px 10px;
  border-radius: 6px;
  text-align: center;
  background-color: hsla(204, 50%, 96%, 0.3);
  box-shadow: 5px 5px 5px 0px rgba(0, 0, 0, 0.75);
  transition: all 0.5s cubic-bezier(0.22, 0.61, 0.36, 1);
  margin: 8px;
}

.admin-item-info:hover {
  transform: translateY(-8px) scale(1.02);
  box-shadow: 0 14px 28px rgba(0, 0, 0, 0.1), 0 10px 10px rgba(0, 0, 0, 0.08);
}

.admin-item-title { font-size: 16px; }
.admin-item { border-radius: 6px; padding: 10px 0; margin-bottom: 10px; }
.admin-left { width: 50%; border-radius: 6px; }
.admin-right { width: 50%; border-radius: 6px; }
.contain-right { width: 60%; border-radius: 6px; margin-right: 40px; display: flex; }

.button-group {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 10px;
}

.btn-login {
  width: 86%;
  padding: 10px;
  border: none;
  border-radius: 40px;
  font-size: 16px;
  cursor: pointer;
  background-color: #4caf50;
}
.btn-login:hover { background-color: #45a049; }

.user-link_img {
  width: 80px;
  height: 80px;
  border: 2px dashed #2fa89a;
}

.user-bottom {
  width: 80%;
  display: flex;
  justify-content: space-around;
  text-align: center;
  padding: 20px 0;
}

.user-input {
  width: 100%;
  padding: 6px 0;
  border-radius: 4px;
  font-size: 14px;
  background-color: rgba(255, 255, 255, 0.2);
}

.user-mid {
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 10px 0;
}
.user-mid input { width: 160px; background-color: rgba(255, 255, 255, 0.2); }

.avatar-uploader-icon {
  font-size: 16px;
  width: 80px;
  height: 80px;
  line-height: 80px;
  text-align: center;
}

.contain-div {
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 2px;
}

.contain-left {
  width: 33%;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 6px;
  padding-top: 20px;
  margin-left: 40px;
}

.home-div {
  width: 100%;
  padding-top: 60px;
  font-size: 16px;
  overflow: hidden;
}

@media only screen and (max-width: 768px) {
  .contain-div { justify-content: center; }
  .contain-left { width: 90% !important; margin-left: 0 !important; }
  .contain-right { width: 90% !important; margin-right: 0 !important; flex-wrap: wrap; }
  .admin-left, .admin-right { width: 100%; }
}
</style>